import axios from "../utils/axios";

export const createSection = (payload) => {
  return axios
    .post("/api/sections/create", payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const updateSection = (sectionId, payload) => {
  return axios
    .put(`/api/sections/${sectionId}/update`, payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const getSections = (payload) => {
  return axios
    .get(`/api/sections`, {
      params: payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const deleteSection = (id) => {
  return axios
    .delete(`/api/sections/${id}/delete`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
